import React from 'react';
import { Immutable } from 'nuclear-js';
import PropTypes from 'prop-types';
import CreateReactClass from 'create-react-class';

import FormattingUtils from 'utils/formatting';

export default CreateReactClass({
    displayName: 'StudentWidget',

    propTypes: {
        students: PropTypes.instanceOf(Immutable.List).isRequired,
        disabled: PropTypes.bool.isRequired,
        onSelectStudents: PropTypes.func.isRequired,
        selectedStudents: PropTypes.instanceOf(Immutable.Set).isRequired,
        selectedStudentBids: PropTypes.instanceOf(Immutable.Set).isRequired,
        batchOptionState: PropTypes.bool.isRequired,
    },

    getInitialState() {
        return {
            studentDropdownOpen: false,
            currentSelectedStudents: null,
            currentSelectedStudentBids: null,
        };
    },

    UNSAFE_componentWillMount() {
        this.setState({
            currentSelectedStudents: this.props.selectedStudents,
            currentSelectedStudentBids: this.props.selectedStudentBids,
        });
        if (this.props.setClearSelectedStudents) {
            this.props.setClearSelectedStudents(this.clearAll);
        }
    },

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (!nextProps.batchOptionState) {
            this.reset();
        }
    },

    reset() {
        this.setState({
            currentSelectedStudents: this.props.selectedStudents,
            currentSelectedStudentBids: this.props.selectedStudentBids,
        });
    },

    onStudentClick(event, student, studentBid) {
        let currentStudents = this.state.currentSelectedStudents;
        let currentStudentBids = this.state.currentSelectedStudentBids;

        // if all students were selected, but now a single one is, remove only selected student
        if (this.allStudentsCurrentlySelectedYn()) {
            currentStudents = currentStudents.delete(student);
            currentStudentBids = currentStudentBids.delete(studentBid);
        } else if (currentStudents == null) {
            currentStudents = Immutable.Set.of(student);
            currentStudentBids = Immutable.Set.of(studentBid);
        } else if (!currentStudents.contains(student)) {
            currentStudents = currentStudents.add(student);
            currentStudentBids = currentStudentBids.add(studentBid);
        } else {
            currentStudents = currentStudents.delete(student);
            currentStudentBids = currentStudentBids.delete(studentBid);
        }
        this.setState({
            currentSelectedStudents: currentStudents,
            currentSelectedStudentBids: currentStudentBids,
        });
        this.props.onSelectStudents(currentStudents, currentStudentBids);
    },

    isCheckboxChecked(value) {
        if (this.state.currentSelectedStudents != null) {
            return this.state.currentSelectedStudents.includes(value);
        } else {
            return false;
        }
    },

    allStudentsCurrentlySelectedYn() {
        if (this.props.students != null && this.state.currentSelectedStudents != null) {
            return this.props.students.size === this.state.currentSelectedStudents.size;
        } else {
            return false;
        }
    },

    checkIndeterminateState() {
        if (this.props.students != null && this.state.currentSelectedStudents != null) {
            if (this.props.students.size === this.state.currentSelectedStudents.size) {
                return false;
            } else if (this.state.currentSelectedStudents.size > 0) {
                return true;
            }
        } else {
            return false;
        }
    },

    clearAll(event) {
        this.setState({
            currentSelectedStudents: Immutable.Set(),
            currentSelectedStudentBids: Immutable.Set(),
        });
        this.props.onSelectStudents();
    },

    checkAll(event) {
        if (!this.allStudentsCurrentlySelectedYn()) {
            this.setState({
                currentSelectedStudents: this.props.selectedStudents, // select all
                currentSelectedStudentBids: this.props.selectedStudentBids,
            });
            this.props.onSelectStudents(this.props.selectedStudents, this.props.selectedStudentBids);
        } else {
            this.setState({
                currentSelectedStudents: Immutable.Set(), // in case of unselecting all
                currentSelectedStudentBids: Immutable.Set(),
            });
            this.props.onSelectStudents();
        }
        event.stopPropagation();
    },

    render() {
        const name = (
            <div
                key="all-students"
                id="batch-print-select-all-students"
                
                onClick={this.checkAll}
                className="student-widget-label"
            >
                <input
                    type="checkbox"
                    data-testid="batch-print-select-all-students"
                    onChange={this.checkAll}
                    checked={this.allStudentsCurrentlySelectedYn()}
                    ref={(input) => {
                        if (input) {
                            input.indeterminate = this.checkIndeterminateState();
                        }
                    }}
                />
                <label>NAME</label>
            </div>
        );
        const studentList = [];
        if (this.props.students) {
            this.props.students.forEach((s) => {
                const student = s.get('fullName');
                const studentName = FormattingUtils.studentFullNameWithInitial(s);
                const studentBid = s.get('studentBid');
                studentList.push(
                    <li
                        key={studentBid}
                        onClick={(event) => this.onStudentClick(event, studentName, studentBid)}
                        id={studentBid}
                    >
                        <input
                            type="checkbox"
                            checked={this.isCheckboxChecked(studentName)}
                            onChange={(event) => this.onStudentClick(event, studentName, studentBid)}
                        />
                        <label>{student}</label>
                    </li>
                );
            });
        }

        return (
            <div className="student-selection">
                {name}
                <ul className="student-list" key="student-list">
                    {studentList}
                </ul>
            </div>
        );
    },
});
